export default __webpack_public_path__ + "static/media/central_andes_2_11.ca2e476c.JPG";